import { apiRequest } from '@/plugins/api.js';
import { apiResponseTypeEnum } from '@/constants/api.js';

export const apiGetNewGameStatus = ({ queryParams }) => apiRequest({
  url: 'api/randomMatchingForIcons',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  return {
    responseEnum: response?.data?.responseEnum,
  };
});

export const apiRetrieveGameCategories = ({ queryParams }) => apiRequest({
  url: 'api/getThematicCategories',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!Array.isArray(responseData) || (responseData.length === 0)) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  return { parsedData: responseData.map(({ type }) => type) };
});

export const apiFinishGame = ({ queryParams }) => apiRequest({
  url: 'api/sendFinishIcons',
  method: 'GET',
  params: queryParams,
});

export const apiSendGameAnswer = ({ queryParams }) => apiRequest({
  url: 'api/sendAnswerIcons',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseStatus = response?.data?.data?.status;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!['CORRECT_ANSWER', 'WRONG_ANSWER'].includes(responseStatus)) {
    return Promise.reject({ responseEnum: null });
  }

  return {
    isCorrect: responseStatus === 'CORRECT_ANSWER',
  };
});

export const apiUseGameJoker = ({ queryParams }) => {
  const __queryParams = new URLSearchParams();

  __queryParams.append('msisdn', queryParams.msisdn);
  __queryParams.append('gameId', queryParams.gameId);
  __queryParams.append('miniGameId', queryParams.miniGameId);
  __queryParams.append('helpType', queryParams.helpType);

  queryParams.possibleAnswers.forEach((text) => {
    __queryParams.append('possibleAnswers', text);
  });

  return apiRequest({
    url: `api/sendJokerIcons?${ __queryParams }`,
    method: 'GET',
  }).then((response) => {
    const responseData = response?.data?.data?.availableAnswers;

    if (!Array.isArray(responseData)) {
      return Promise.reject({ responseEnum: apiResponseTypeEnum.SERVER_ERROR });
    }

    return { parsedData: responseData };
  });
};

export const apiGetBonusGameStatus = ({ queryParams }) => apiRequest({
  url: 'api/getBonusAddOnGameAvailable',
  method: 'GET',
  params: queryParams,
}).then((response) => {
  return {
    canPlay: response?.data?.responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS,
  };
});

export const apiFinishBonusGame = ({ payload }) => apiRequest({
  url: 'api/updateDBonusAddOnGamesIcons',
  method: 'POST',
  data: payload,
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  }
});
